// extracted by mini-css-extract-plugin
export default {"container":"layout-styles_component_container__kXX+7","header":"layout-styles_component_header__KoEp9","content":"layout-styles_component_content__S19RE"};